import styles from "./styles";
import { formatMillisToMinutesAndSeconds } from "../../../../utils/dateUtil";
import { IconButton, Typography } from "@mui/material";
import PositiveFaceIcon from "@mui/icons-material/SentimentSatisfiedAlt";
import NegativeFaceIcon from "@mui/icons-material/SentimentVeryDissatisfied";
import NeutralFaceIcon from "@mui/icons-material/SentimentNeutral";
import useCss from "../../../../hooks/useCss";
import type { HistoryRow, TranscriptEntry } from "../common/Row";

interface TranscriptContentProps {
  data: HistoryRow;
}

type SentimentKey = "NEUTRAL" | "NEGATIVE" | "POSITIVE";

const TranscriptContent = ({ data }: TranscriptContentProps) => {
  const classes = useCss(styles);
  const sortedTranscripts = [...(data?.transcripts ?? [])].sort(
    (t1: TranscriptEntry, t2: TranscriptEntry) =>
      t1.BeginOffsetMillis - t2.BeginOffsetMillis,
  );

  const IconMap = {
    NEUTRAL: <NeutralFaceIcon sx={{ fontSize: "24px" }} />,
    NEGATIVE: <NegativeFaceIcon sx={{ fontSize: "24px" }} />,
    POSITIVE: <PositiveFaceIcon sx={{ fontSize: "24px" }} />,
  };

  const SENTIMENT_BTN_COLOR = {
    NEUTRAL: "action", // mui color
    NEGATIVE: "#d62b1f",
    POSITIVE: "#00754A",
  };

  const displayTranscripts = () => {
    return sortedTranscripts.map((transcript, key) => {
      return (
        <div key={key} className={`${classes.transcriptHeaderDiv}`}>
          <div className={`${classes.flexHeader}`}>
            <Typography variant="h5" className={classes.participantHeaderText}>
              <b>{transcript?.["ParticipantId"]}</b>
            </Typography>
            <span className={classes.durationText}>
              {formatMillisToMinutesAndSeconds(transcript?.["EndOffsetMillis"])}
            </span>
          </div>
          <div className={`${classes.transcriptContentDiv}`}>
            <IconButton
              sx={{
                color:
                  SENTIMENT_BTN_COLOR[transcript?.Sentiment as SentimentKey],
              }}
              title={transcript?.Sentiment}
            >
              {IconMap[transcript.Sentiment as SentimentKey]}
            </IconButton>
            <div className={classes.transcriptDiv}>
              <span>{transcript.Content}</span>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className={classes.transcriptWrapperDiv}>{displayTranscripts()}</div>
  );
};

export default TranscriptContent;
